

















































import { Component, Vue } from 'vue-property-decorator';
import { ObjectFactory } from '../../config/objectFactory';
import { required } from 'vuelidate/lib/validators';
import { CommonUtils } from '@/util/commonUtils';

@Component({
    props: {
        paymentCustomerId: {
            type: String,
            required: false,
        },
        billingLocationIds: {
            type: Array,
            required: false,
            default: () => [],
        },
    },
    data() {
        return {
            selectedPaymentSource: null as any,
        };
    },
    validations: {
        selectedPaymentSource: {
            required,
        },
    },
})

export default class AddLocationModal extends Vue {
    private show = true;
    private paymentSources: [] = [];

    public mounted() {
        this.getListPaymentSource('card');
    }

    private async getListPaymentSource(paymentMethod: 'bank_account' | 'card') {
        const locationIds = this.$props.billingLocationIds;
        const response = await ObjectFactory.getPaymentSourceService().getListPaymentSource(paymentMethod,
            this.$store.state.serverUrl, this.$props.paymentCustomerId, locationIds);
        this.paymentSources = response.data;
    }

    private async setPrimaryPaymentSource() {
        const patmentCustomerId = this.$data.selectedPaymentSource ?  this.$data.selectedPaymentSource.customer : '';
        const response = await ObjectFactory.getPaymentSourceService().
            setDefaultPaymentSource(this.$data.selectedPaymentSource.id, this.$store.state.serverUrl,
            patmentCustomerId);
        if (response.success) {
            this.$emit('close');
            this.$emit('success', {
                customerId: this.$data.selectedPaymentSource.customer,
            });
        } else {
            CommonUtils.showError(response);
        }
    }

    private close() {
        this.$emit('close');
    }
}
